import script from "./comment-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./comment-editor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__